// Validation constants
export const PLAYLIST_NAME_LIMIT = 50;
export const PLAYLIST_DESCRIPTION_LIMIT = 200;

// Validation functions
export const validatePlaylistName = (name: string): string | null => {
    if (!name.trim()) {
        return "Playlist name is required";
    }
    if (name.length > PLAYLIST_NAME_LIMIT) {
        return `Name must be ${PLAYLIST_NAME_LIMIT} characters or less`;
    }
    return null;
};

export const validatePlaylistDescription = (description: string): string | null => {
    if (description.length > PLAYLIST_DESCRIPTION_LIMIT) {
        return `Description must be ${PLAYLIST_DESCRIPTION_LIMIT} characters or less`;
    }
    return null;
};

export const isValidPlaylistData = (name: string, description: string): boolean => {
    return validatePlaylistName(name) === null && validatePlaylistDescription(description) === null;
}; 